import '@mdi/font/css/materialdesignicons.css'
// import Vue from 'vue'
import Vuetify, { VTabItem } from 'vuetify/lib'

// Vue.use(Vuetify, {
//   VTabItem
// })

// export default new Vuetify({
// })

export default (Vue) => {
  Vue.use(Vuetify, {
    VTabItem
  })
  return new Vuetify()
}
